export enum CodeUniteTemps {
	SECONDE = 'secondes',
	MINUTE = 'minutes',
	HEURE = 'heures',
	JOUR = 'jours'
}
